import { createGlobalStyle } from "styled-components";


const HelperClass = createGlobalStyle`
        
    *:focus { outline:0 !important; }
    
    body {
        width: 100%;
        min-height: 100vh;
        margin: 0;
        padding: 0;
        color: var(--black);
        -webkit-overflow-scrolling: touch;
        overflow-x: hidden;
        position: relative;
        background-color:var(--white);


        main.page {
            min-height: 100vh;
            z-index: 1;
            position: relative;
            overflow:hidden;

            @media screen and (min-width:602px){

                &.home {
                    padding-bottom:var(--sp10x);
                }
            }
        }

        #root {
            overflow-x: hidden;
        }

    }

    ul,
    fieldset {
        margin: 0;
        padding: 0;
        list-style: none;
        border: none;
    }

    a {
        text-decoration: none;
        color: inherit;

        &:hover {
            color:inherit;
        }
    }

    // flex

    .flexBoxWrap {
        display: flex;
        flex-wrap: wrap;
    }

    .flexBoxColumn {
        display: flex;
        flex-direction: column;
    }

    .flexBox {
        display: flex;
    }

    .alignMiddle {
        align-items: center;
    }

    .alignCenter {
        justify-content: center;
    }
    
    .alignStart{
        align-items: flex-start;
    }
    
    .alignEnd{
        align-items: flex-end;
    }

    .justifyEnd{
        justify-content: flex-end;
    }

    .spaceBetween {
        justify-content: space-between;
    }

    .newLineText {
        white-space: pre-line;
    }


    //!Colors
    .black {
        color: var(--black);
    }

    .white {
        color: var(--white);
    }

    .green{
        color: var(--green);
    }
    
    .purple{
        color: var(--purple);
    }

    .coral{
        color:var(--coral);
    }

    .orange{
        color: var(--orange);
    }
    .darkGrey{
        color: var(--darkGrey);
    }

    .grey{
        color: var(--grey);
    }
    .lightGrey{
        color: var(--lightGrey);
    }
    .lightYellow{
        color: var(--lightYellow);
    }
    .lightPurple{
        color: var(--lightPurple);
    }
    .lightBlue{
        color: var(--lightBlue);
    }

    //errorColor
    .errorColor {
      color:var(--errorColor);
    }

    //! Margins
    body {
        .titleMarginBottom {
            margin-bottom:var(--titleMarginBottom);
        }
        
        .subtitleMarginBottom {
            margin-bottom:var(--subtitleMarginBottom);
        }
        
        .sectionMarginBottom {
            margin-bottom: var(--sectionMarginBottom);
        }
    }

    //!Social buttons

    .social-btn-login {
        padding:18px;
        display: flex;
        align-items: center;
        border-radius: 12px;
        -webkit-appearance: none;
        border:none;
        transition: var(--trTime) ease-out;
        margin-bottom: var(--sp2x);

        &.google {
            background-color: #F2F2F2;
        }
        
        &.facebook {
            background-color: #0077B7;
        }
        
        &.linkedin {
            background-color: #475993;
        }

        i {
            font-size: 20px;
            margin-right: var(--sp2x);
        }

        .comp-title {
            font-size: 14px;
        }
    }

    //! Line clamp
    
    .line-clamp {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;  
        overflow: hidden;
    }
`

export default HelperClass